import {MENUS} from "../menu";

export const ROUTER_NAMES = {
    UNIDADE: 'Unidade'
}

export default [
    {
        name: ROUTER_NAMES.UNIDADE,
        path: '/unidade',
        meta: {
            menu: MENUS.CADASTRO,
            title: 'Unidade',
            searchAlias: 'Unidade',
            searchDescription: 'Veja todas as Unidades cadastradas',
            searchTerms: ['Unidade'],
            hasRole: 'role/unidade'
        },
        component: () => import('@/views/Unidade')
    },
]